import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { getAiPoints } from "@/lib/api";

export const AI_POINTS_REFRESH = "ai-points:refresh";

export default function AiPointsBadge({ user }) {
  const recId = user?.user_record_id || user?.record_id;
  const [pts, setPts] = useState(null);
  const [pop, setPop] = useState(false);

  useEffect(() => {
    if (!recId) return;
    let alive = true;
    const load = (celebrate) => getAiPoints(recId)
      .then((r) => { if (!alive) return; setPts(r.balance); if (celebrate) { setPop(true); setTimeout(() => setPop(false), 1800); } })
      .catch(() => alive && setPts(null));
    load(false);
    const onRefresh = () => load(true);
    window.addEventListener(AI_POINTS_REFRESH, onRefresh);
    return () => { alive = false; window.removeEventListener(AI_POINTS_REFRESH, onRefresh); };
  }, [recId]);

  if (pts == null) return null;
  return (
    <Link to="/app/profile?tab=design" title="Your AI points — spend them on emails, videos, posts and your AI agent"
      className={`shrink-0 inline-flex items-center gap-1 h-8 pl-2 pr-2.5 rounded-full border text-xs font-bold transition-all duration-300 ${pop ? "bg-violet-600 text-white border-violet-600 scale-110 shadow-[0_6px_18px_#7c3aed66]" : "bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-100"}`}
      data-testid="topnav-ai-points">
      <Sparkles size={13} /> <span data-testid="topnav-ai-points-value">{pts}</span><span className="hidden sm:inline font-semibold opacity-80"> pts</span>
    </Link>
  );
}
